import Vue from 'vue';
import App from './RaumResRoomSearchApp.vue';

window.Apps = window.Apps || {};
Apps.initRaumResRoomSearch = function (data) {
    new Vue({
        el: '#raumres-roomsearch-app',
        data: data,
        render: h => h(App)
    });
};